import LocateAddress from './LocateAddress';

export default LocateAddress;